<template>
  <div class="tree-node-wrapper">
    <div class="tree-node-content d-flex" @click="toggleExpand">
      <v-icon v-if="hasChildren" small class="mr-2">
        {{ isExpanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
      </v-icon>
      <div class="tree-node-text">{{ item.treeViewText }}</div>
      <slot name="append" :item="item"></slot>
    </div>

    <draggable
      v-if="hasChildren && isExpanded"
      v-model="item.treeViewChildren"
      tag="ul"
      :group="'node-' + item.treeViewId"
      class="nested-tree-list"
      @end="onDragEnd"
    >
      <li v-for="child in item.treeViewChildren" :key="child.treeViewId">
        <DraggableTreeviewNode
          :item="child"
          @update-tree-structure="$emit('update-tree-structure')"
        >
          <template v-slot:append="{ item: subItem }">
            <slot name="append" :item="subItem"></slot>
          </template>
        </DraggableTreeviewNode>
      </li>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import DraggableTreeviewNode from './DraggableTreeviewNode.vue'

export default {
  name: 'DraggableTreeviewNode',
  components: {
    draggable,
    DraggableTreeviewNode,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isExpanded: false,
    }
  },
  computed: {
    hasChildren() {
      return this.item.treeViewChildren && this.item.treeViewChildren.length > 0
    },
  },
  methods: {
    toggleExpand() {
      if (this.hasChildren) {
        this.isExpanded = !this.isExpanded
      }
    },
    onDragEnd() {
      this.item.fields = [...this.item.treeViewChildren]
      this.$emit('update-tree-structure')
    },
  },
}
</script>

<style scoped>
.tree-node-wrapper {
  margin-left: 24px;
}
.tree-node-content {
  cursor: pointer;
  padding: 8px 0;
  border: 1px solid #e0e0e0;
  background-color: #f5f5f5;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
}
.tree-node-text {
  flex-grow: 1;
  padding-left: 8px;
}
.nested-tree-list {
  list-style-type: none;
  padding: 0;
}
</style>
